import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './PersonalityName.module.scss';

const PersonalityName = ({ theme = {}, text }) => {
  if (!text) return null;
  return <div className={classNames(style.headline, theme.headline)}>{text}</div>;
};

PersonalityName.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default PersonalityName;
